import { useEffect, useState } from 'react';

export function useConversationSelection(
    deepLinkConversationId: string | undefined,
) {
    const [selectedId, setSelectedId] = useState<string | null>(
        () => deepLinkConversationId ?? null,
    );

    useEffect(() => {
        setSelectedId(deepLinkConversationId ?? null);
    }, [deepLinkConversationId]);

    return [selectedId, setSelectedId] as const;
}
